import { createSlice } from '@reduxjs/toolkit';
import { REQUEST_STATUS } from '@shared/constants/otherConstants';
import { getArrayLookupObject } from '@shared/utils/utilsOld';

const modulesSlice = createSlice({
    name: '@modules',
    initialState: {
        modules: [],
        modulesLookup: {},
        getStatus: REQUEST_STATUS.NOT_REQUESTED,
        getError: null,
        addStatus: REQUEST_STATUS.NOT_REQUESTED,
        addError: null,
        editStatus: REQUEST_STATUS.NOT_REQUESTED,
        editError: null,
        editedModule: null,
        deleteStatus: REQUEST_STATUS.NOT_REQUESTED,
        deleteError: null,
    },
    reducers: {
        // READ
        getModulesRequest(state) {
            state.getStatus = REQUEST_STATUS.LOADING;
            state.getError = null;
            state.modulesLookup = {};
        },
        getModulesSuccess(state, action) {
            state.getStatus = REQUEST_STATUS.SUCCESS;
            state.getError = null;
            state.modules = action.payload.data;
            state.modulesLookup = getArrayLookupObject(action.payload.data);
        },
        getModulesError(state, action) {
            state.getStatus = REQUEST_STATUS.ERROR;
            state.getError = action;
            state.modules = [];
            state.modulesLookup = {};
        },
        getModulesReset(state) {
            state.getStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.getError = null;
            state.modulesLookup = {};
        },

        // CREATE
        addModuleRequest(state) {
            state.addStatus = REQUEST_STATUS.LOADING;
            state.addError = null;
        },
        addModuleSuccess(state) {
            state.addStatus = REQUEST_STATUS.SUCCESS;
            state.addError = null;

            state.getStatus = REQUEST_STATUS.NOT_REQUESTED; // after adding module, need to get the list of modules again
            state.getError = null;
        },
        addModuleError(state, action) {
            state.addStatus = REQUEST_STATUS.ERROR;
            state.addError = action;
        },
        addModuleReset(state) {
            state.addStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.addError = null;
        },

        // UPDATE
        editModuleRequest(state) {
            state.editStatus = REQUEST_STATUS.LOADING;
            state.editError = null;
            state.editedModule = null;
        },
        editModuleSuccess(state, action) {
            state.editStatus = REQUEST_STATUS.SUCCESS;
            state.editError = null;
            state.editedModule = action.payload.data;
        },
        editModuleError(state, action) {
            state.editStatus = REQUEST_STATUS.ERROR;
            state.editError = action;
            state.editedModule = null;
        },
        editModuleReset(state) {
            state.editStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.editError = null;
            state.editedModule = null;
        },

        // DELETE
        deleteModuleRequest(state) {
            state.deleteStatus = REQUEST_STATUS.LOADING;
            state.deleteError = null;
        },
        deleteModuleSuccess(state) {
            state.deleteStatus = REQUEST_STATUS.SUCCESS;
            state.deleteError = null;

            state.getStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.getError = null;
        },
        deleteModuleError(state, action) {
            state.deleteStatus = REQUEST_STATUS.ERROR;
            state.deleteError = action;
        },
        deleteModuleReset(state) {
            state.deleteStatus = REQUEST_STATUS.NOT_REQUESTED;
            state.deleteError = null;
        },
    },
});

export default modulesSlice.reducer;

export const {
    getModulesRequest,
    getModulesSuccess,
    getModulesError,
    getModulesReset,
    addModuleRequest,
    addModuleSuccess,
    addModuleError,
    addModuleReset,
    editModuleRequest,
    editModuleSuccess,
    editModuleError,
    editModuleReset,
    deleteModuleRequest,
    deleteModuleSuccess,
    deleteModuleError,
    deleteModuleReset,
} = modulesSlice.actions;
